const selectors = {
    wizards: (state) => state?.wizard?.wizards,
    wizardName: (router) => router?.query && router.query.id || router.query.completedWizard,
    wizardTypes: (state) => Object.keys(selectors.wizards(state)),
    thisWizard: ({ state, router }) => {
        const wizards = selectors.wizards(state) || {}
        const wizardName = selectors.wizardName(router) || ''

        return wizards[wizardName]
    },
    thisWizardPayload: ({ state, router }) => {
        const thisWizard = selectors.thisWizard({ state, router })

        return thisWizard?.submit?.payload || {}
    },
    thisWizardPopupId: ({ state, router }) => {
        const thisWizard = selectors.thisWizard({ state, router })

        return thisWizard?.submit?.payload?.popupId || null
    },
    thisWizardSignupEmail: ({ state, router }) => {
        const thisWizard = selectors.thisWizard({ state, router })

        return thisWizard?.submit?.payload?.signupEmail || null
    },
    thisWizardProductOptionId: ({ state, router }) => {
        const thisWizard = selectors.thisWizard({ state, router })

        return thisWizard?.submit?.payload?.optionId || null
    },
}

export default selectors
